import { getClient } from "./client";
import type { ApiGameMessage } from "./shared";

export const getMessagesByGameId = (gameId: string) =>
  getClient().get(`/api/games/${gameId}/messages`).json<ApiGameMessage[]>();
